/* eslint-disable no-unused-vars */
import { Component, lazy } from "react";
import ROUTES from "./routes";
import HttpClient from "@services/HttpClient";
import NotFound from "@pages/NotFound";
import {
    withSeoData,
    createEntityMeta,
    isProductionEnvironment,
    getListLanguages,
} from "@lib/utils";
import { parse } from "cookie";
import { Book } from "lucide-react";
import { format } from "date-fns";
import { BookingService } from "@services/BookingService";
import { CountryService } from "@services/CountryService";
import { PlaceService } from "@services/PlaceService";

const routes = [
    {
        path: ":lang_id",
        Component: lazy(() => import("@layouts/LanguageLayout")), // Layout này sẽ xử lý đổi ngôn ngữ
        loader: ({ params }) => {
            const languages = getListLanguages();
            const lang = languages.find((item) => item.key === params.lang_id);
            if (!lang) {
                throw new Response(null, {
                    status: 404,
                });
            }

            return true;
        },
        children: [
            {
                id: "place-preview-root",
                Component: lazy(() => import("@layouts/Root")),
                loader: async ({ params }) => {
                    const { lang_id, place_id } = params;
                    const [dataPlace] = await Promise.all([
                        PlaceService.getPlaceById(),
                    ]);
                    return {
                        langId: lang_id,
                        placeId: place_id,
                        dataPlace,
                    };
                },
                children: [
                    {
                        index: true,
                        Component: lazy(() => import("@pages/Home")),
                        loader: async ({ params }) => {
                            const lang_id = params.lang_id;
                            return {
                                lang_id,
                            };
                        },
                    },

                    {
                        path: ROUTES.PAYMENT_INFORMATION,
                        Component: lazy(() =>
                            import("@pages/Payment/PaymentInfo")
                        ),
                        loader: async ({ params }) => {
                            const lang_id = params.lang_id;
                            const [listCountry] = await Promise.all([
                                CountryService.getCountries({
                                    lang_id: lang_id,
                                }),
                            ]);
                            return {
                                lang_id,
                                listCountry,
                            };
                        },
                    },
                    {
                        path: ROUTES.PAYMENT_SUCCESS,
                        Component: lazy(() => import("@pages/PaymentSuccess")),
                        loader: async ({ params }) => {
                            const lang_id = params.lang_id;
                            const transaction_code = params.transactionTd;
                            const [getBookingInfo] = await Promise.all([
                                BookingService.getBookingInfoByTransactionCode({
                                    transaction_code,
                                    lang_id,
                                }),
                            ]);
                            return {
                                lang_id,
                                bookingInfo: getBookingInfo,
                            };
                        },
                    },
                ],
            },

            {
                path: ROUTES.NOT_FOUND,
                Component: NotFound,
            },
        ],
        ...(isProductionEnvironment() && { errorElement: <NotFound /> }),
    },
    {
        path: "*",
        Component: NotFound,
    },
];

export default routes;
